export default __webpack_public_path__ + "static/media/lp-logo-footer@2x.442c898f.png";